import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1274ae98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry-overflow" }
const _hoisted_2 = { class: "entry-content entry-content--scroll" }
const _hoisted_3 = { class: "entry-content_new" }
const _hoisted_4 = {
  key: 1,
  class: "entry-content"
}
const _hoisted_5 = { class: "entry-content_empty" }


const __default__ = {
  name: 'CreateNav'
}

import { computed, ref, watchEffect } from 'vue'
import EmptyView from '@teams/common/components/error/empty.vue'
import EntryNewNav from '@/components/navigator/AddOrUpdateNav/entryNewNav.vue'
import useAddOrUpdateNav from '@teams/common/hooks/useAddOrUpdateNav'
import { useAcl } from 'vue-simple-acl'
import aclRules from '@teams/common/acl/aclRules'
import { useNavigatorStore } from '@/store/navigator'
import { Nav } from '@teams/common/models'
import { useWindowSize } from '@vueuse/core'
import handleResponseError from '@teams/common/hooks/useResponseError'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    navId: null
  },
  setup(__props: any) {

const props = __props as {
  navId: number
}

_useCssVars(_ctx => ({
  "bbebd15a": (contentTop.value)
}))



const navigatorStore = useNavigatorStore()
const activeNav = computed(() =>
  navigatorStore.list.find(nav => nav.id === props.navId)
)
const acl = useAcl()
// rbac创建标签
const rbacCreateNav = computed(() => acl.can(aclRules.navigation_add_tag))
const { updateView } = useAddOrUpdateNav({
  initialValue: (activeNav.value || {}) as Nav
})
const updateType = async params => {
  try {
    await updateView({
      kind: params.navType,
      finder: params.finder,
      isNewFile: params.isNewFile
    })
  } catch (e) {
    handleResponseError(e)
  }
}
const updateName = async params => {
  await updateView({
    icon: params.icon,
    name: params.name,
    auto_update: params.autoUpdate
  })
}
// 上边距=((屏幕高度-导航栏高度-新建页内容高度)/3)
const { height } = useWindowSize()
const contentTop = ref()
watchEffect(() => {
  if ((height.value - 104 - 394) / 3 >= 120) {
    contentTop.value = (height.value - 104 - 394) / 3 + 'px'
  } else {
    contentTop.value = 120 + 'px'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_NScrollbar = _resolveComponent("NScrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(rbacCreateNav))
      ? (_openBlock(), _createBlock(_component_NScrollbar, {
          key: 0,
          "x-scrollable": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(EntryNewNav, {
                  onUpdateType: updateType,
                  onUpdateName: updateName
                })
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(EmptyView, { title: "该标签页暂无内容" })
          ])
        ]))
  ]))
}
}

})